var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.5001V10.6251H8.375L4.75588 14.2476C6.00458 15.5245 7.71402 16.246 9.5 16.2501C12.3569 16.2459 14.9017 14.4436 15.854 11.7501H15.8743C16.0031 11.384 16.1006 11.0077 16.1656 10.6251H18.4291C17.8622 15.125 14.0355 18.4999 9.5 18.5001H9.48875C7.10236 18.5072 4.81231 17.5593 3.12912 15.8676L0.5 18.5001ZM2.83325 8.37509H0.56975C1.13647 3.8769 4.96062 0.502503 9.49438 0.500046H9.5C11.8868 0.492409 14.1774 1.44041 15.8608 3.13259L18.5 0.500046V8.37509H10.625L14.2498 4.75259C12.9998 3.47419 11.288 2.7525 9.5 2.75009C6.64312 2.75431 4.09829 4.5566 3.146 7.25009H3.12575C2.99588 7.61584 2.89838 7.99228 2.83438 8.37509H2.83325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.0481641bfab5fc03076a949a0f89738d.svg";
export { ForwardRef as ReactComponent };